import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import MintUI from 'mint-ui'

Vue.use(Router)
Vue.use(MintUI)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../view/download/kawden.vue'),
      meta: {
        title: 'KK Home'
      }
    },
    {
      path: '/share/*',
      name: 'share',
      component: () => import('../view/share/share')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('../view/share/share')
    },
    // {
    //   path: '/legal/kawden_privacy_term_en',
    //   name: 'privacyTerm',
    //   component: () => import('../view/userAgreement/kawden_privacy_term_en')
    // },
    // {
    //   path: '/legal/kawden_user_term_en',
    //   name: 'userTerm',
    //   component: () => import('../view/userAgreement/kawden_user_term_en')
    // },
    // {
    //   path: '/legal/kawden_user_term_es',
    //   name: 'userTerm',
    //   component: () => import('../view/userAgreement/kawden_user_term_es')
    // },
    // {
    //   path: '/legal/kawden_user_term_es',
    //   name: 'userTerm',
    //   component: () => import('../view/userAgreement/kawden_user_term_es')
    // },
    {
      path: '/alexa',
      name: 'alexa',
      component: () => import('../view/alexa/alexa')
    },
    {
      path: '/download',
      name: 'APP Download',
      component: () => import('../view/download/revolo'),
      meta: {
        title: 'Download'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../view/faq/Faq'),
      meta: {
        title: 'FAQ'
      }
    },
    {
      path: '/faq/questionList',
      name: 'questionList',
      component: () => import('../view/faq/QuestionList'),
      meta: {
        title: 'FAQ'
      }
    },
    {
      path: '/faq/questionDetails',
      name: 'questionDetails',
      component: () => import('../view/faq/QuestionDetails'),
      meta: {
        title: 'FAQ'
      }
    },

    {
      path: '/video',
      name: 'video',
      component: () => import('../view/video/VideoList'),
      meta: {
        title: 'Installation'
      }
    },
    {
      path: '/video/type',
      name: 'videoType',
      component: () => import('../view/video/VideoType'),
      meta: {
        title: 'Installation'
      }
    },
    // {
    //   path: '/installation/s0q01-k/*',
    //   name: 'installationEn',
    //   component: () => import('../view/pdf/installationEn')
    // },


    // {
    //   path: '/installation/s0q01-k/es*',
    //   name: 'installationEs',
    //   component: () => import('../view/pdf/installationEs')
    // },
    // {
    //   path: '/installation/s0v01-k/*',
    //   name: 'installationEn',
    //   component: () => import('../view/pdf/installationWfvEn')
    // },
    // {
    //   path: '/installation/s0v01-k/es*',
    //   name: 'installationEs',
    //   component: () => import('../view/pdf/installationWfvEs')
    // },
    // {
    //   path: '/installation/S0V01-JR/*',
    //   name: 'installationJRWFVEn',
    //   component: () => import('../view/pdf/installationjrwfvEn')
    // },
    // {
    //   path: '/installation/S0V01-JR/es*',
    //   name: 'installationJRWFVEn',
    //   component: () => import('../view/pdf/installationjrwfvEn')
    // },
    {
      path: '/installation/P0A81/*',
      name: 'installationTe002wEn',
      component: () => import('../view/pdf/installationte002wEn')
    },
    // {
    //   path: '/installation/P0A81/es*',
    //   name: 'installationTe002wEn',
    //   component: () => import('../view/pdf/installationte002wEn')
    // },
    // {
    //   path: '/installation/V0Q02-JR/*',
    //   name: 'installationTe002wEn',
    //   component: () => import('../view/pdf/installationJrEn')
    // },
    // {
    //   path: '/installation/V0Q02-JR/es*',
    //   name: 'installationTe002wEn',
    //   component: () => import('../view/pdf/installationJrEn')
    // },
    // {
    //   path: '/installation/V0A82/*',
    //   name: 'installationKW217',
    //   component: () => import('../view/pdf/installationKW217')
    // },
    // {
    //   path: '/installation/V0A84/*',
    //   name: 'installationKW217',
    //   component: () => import('../view/pdf/installationKW217')
    // },
    // {
    //   path: '/installation/V0Q01/*',
    //   name: 'installationV0Q01',
    //   component: () => import('../view/pdf/installationKW216')
    // },
    {
      path: '/video/info',
      name: 'videoPlayer',
      component: () => import('../view/video/VideoPlayer'),
      meta: {
        title: 'Installation'
      }
    },

    {
      path: '/code/*',
      name: 'code',
      component: () => import('../view/code/CodeViewer'),
      meta: {
        title: 'code'
      }
    },
    // 添加操作手册pdf路由 放在最后
    {
      path: '/installation/',
      name: 'installation',
      component: () => import('../view/pdf/installation')
    },
    {
      path: '/installation/list',
      name: 'installation',
      component: () => import('../view/pdf/installation')
    },
    // pdf-reader
    {
      path: '/installation/:model/:language',
      name: 'installation',
      component: () => import('../view/pdf/pdf-reader')
    },
    // legal
    {
      path: '/legal/kawden_privacy_term_en',
      name: 'kawden_privacy_term_en',
      component: () => import('../view/legal/kawden_privacy_term_en.vue')
    },
    {
      path: '/legal/kawden_privacy_term_es',
      name: 'kawden_privacy_term_es',
      component: () => import('../view/legal/kawden_privacy_term_es.vue')
    },
    {
      path: '/legal/kawden_user_term_en',
      name: 'kawden_user_term_en',
      component: () => import('../view/legal/kawden_user_term_en.vue')
    },
    {
      path: '/legal/kawden_user_term_es',
      name: 'kawden_user_term_es',
      component: () => import('../view/legal/kawden_user_term_es.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js